/**
 * Client-safe default terminology (no Prisma/Node dependencies).
 * Use this in client components instead of TerminologyService.getDefaultTerminology().
 */

import type { OrganizationTerminology } from "./terminologyTypes";

/**
 * Default terminology used when organization has none or as fallback in client components.
 * Must stay in sync with TerminologyService.getDefaultTerminology().
 */
export const DEFAULT_TERMINOLOGY: OrganizationTerminology = {
  area: { plural: "Areas", singular: "Area" },
  caseWorker: { plural: "Case Workers", singular: "Case Worker" },
  category: { plural: "Categories", singular: "Category" },
  donation: { plural: "Donations", singular: "Donation" },
  need: { plural: "Needs", singular: "Need" },
  story: { plural: "Stories", singular: "Story" },

  termActive: "Active",
  termAvailable: "Available",
  termBrowse: "Browse",
  termClaim: "Claim",
  termClaimed: "Claimed",
  termCommunity: "Community",

  termCompleted: "Completed",
  termDonate: "Donate",
  termImpact: "Impact",
  termJoinUs: "Join Us",

  termRespond: "Respond",
  termServiceAreas: "Service Areas",
  termSubmit: "Submit",
  volunteer: { plural: "Volunteers", singular: "Volunteer" },
};
